import { useEffect, useState } from "react";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import Grid from "@mui/material/Grid2";
import {
  Box,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Fab,
  FormControl,
  FormHelperText,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import MaterialBox from "../../../components/MaterialBox";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import MaterialInput from "../../../components/MaterialInput";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import axios from "axios";
import BASEURL, { pdfurl } from "../../Utils/Baseurl";
import { useLoading } from "../../../context/loading";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Pdfdialog from "./Pdfdialog";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
const AllocateTask = () => {
  const data = sessionStorage.getItem("user");
  const task = sessionStorage.getItem("mytask")
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  console.log(id); // Output: 34
  
  const nav = useNavigate();
  const parsedData = JSON.parse(data);
  console.log("parsedData:", parsedData);
  const userid = parsedData?.id;
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [status, setstatus] = useState({
    view: false,
    edit: false,
  });

  const[files,setfiles] = useState([])

  //popupopen
  const[open,setopen] = useState(false)
  console.log(status, "statuss");

  const [Allprojects, setAllprojects] = useState([]);
  const [Employee, setEmployee] = useState([]);
  const { setCirleLoading } = useLoading();

  const [prioritylevel, setprioritylevel] = useState([
    {
      value: "high",
      label: "High",
    },
    {
      value: "medium",
      label: "Medium",
    },
    {
      value: "low",
      label: "Low",
    },
  ]);

    const [statusoptions, setstatusoptions] = useState([
    {
      value: "pending",
      label: "Pending",
    },
    {
      value: "in_progress",
      label: "In Progress",
    },
    {
      value: "completed",
      label: "Completed",
    },
  ]);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [filename, setfilename] = useState("");
  const [taskdetails, setTaskdetails] = useState({
    projectname: "",
    projectnameStatus: "unchecked",
    employee: "",
    employeeStatus: "unchecked",
    title: "",
    titleStatus: "unchecked",
    description: "",
    descriptionStatus: "unchecked",
    prioritylevel: "",
    prioritylevelStatus: "unchecked",
    status:"",
    statusStatus:"unchecked",
    estimatedhours: "",
    estimatedhoursStatus: "unchecked",
    startdate: "",
    startdateStatus: "unchecked",
    enddate: "",
    enddateStatus: "unchecked",
    duedate: "",
    duedateStatus: "unchecked",
    file: "",
    fileStatus: "unchecked",
  });

  console.log(taskdetails, "taskkkdett");

  useEffect(() => {
    fetchprojects();
    fetchemployee();
  }, []);

  useEffect(() => {
    if (id) {
      fetchtaskbyid(id);
      setstatus({
        edit: false,
        view: true,
      });
    }
  }, [id]);

  const handletaskdetails = (feild, value) => {
    //   setTaskdetails((prev)=>({
    //        ...prev,
    //        [feild]:value
    //      }))

    const updatedtaskdetails = { ...taskdetails };
    switch (feild) {
      case "projectname":
        if (value) {
          updatedtaskdetails.projectnameStatus = "success";
        }

        break;

      case "employee":
        if (value) {
          updatedtaskdetails.employeeStatus = "success";
        }

        break;

      case "title":
        if (value.length > 4) {
          updatedtaskdetails.titleStatus = "success";
        } else {
          updatedtaskdetails.titleStatus = "error";
        }

        break;

      case "description":
        if (value.length > 10) {
          updatedtaskdetails.descriptionStatus = "success";
        } else {
          updatedtaskdetails.descriptionStatus = "error";
        }

        break;

      case "prioritylevel":
        if (value) {
          updatedtaskdetails.prioritylevelStatus = "success";
        }

        break;

         case "status":
        if (value) {
          updatedtaskdetails.statusStatus = "success";
        }

        break;

      case "estimatedhours":
        if (value) {
          updatedtaskdetails.estimatedhoursStatus = "success";
        }

        break;

      case "startdate":
        if (value) {
          if (taskdetails.duedate && taskdetails.duedate < value) {
            updatedtaskdetails.startdateStatus = "error";
          } else {
            updatedtaskdetails.startdateStatus = "success";
          }
        }

        break;
      case "enddate":
        if (value) {
          if (taskdetails.startdate && value < taskdetails.startdate) {
            updatedtaskdetails.enddateStatus = "error";
          } else {
            updatedtaskdetails.enddateStatus = "success";
          }
        }

        break;

      case "duedate":
        if (value) {
          // updatedtaskdetails.duedateStatus = "success";
           if (taskdetails.startdate && value < taskdetails.startdate) {
            updatedtaskdetails.duedateStatus = "error";
          } else {
            updatedtaskdetails.duedateStatus = "success";
          }
        }

        break;

      case "file":
       

        const files = Array.from(value.target.files);

        console.log(files,"allfiles");
        
         // Convert FileList to array
        console.log(
          "Selected files:",
          files.map((f) => f.name)
        );

          const allowedFiles = files.filter(file => file.size <= 1000 * 1024); // 1000 KB

    if (allowedFiles.length < files.length) {
        alert("Some files were too large and have been skipped (must be under 1000 KB).");
    }

         const filewithurl =   allowedFiles?.map((file)=>({
           name:file?.name,
           url:URL.createObjectURL(file)
         }))

         setfiles(filewithurl)

        setfilename(allowedFiles.map((f) => f.name + ",")); // Optional: if you want to show names

        updatedtaskdetails[feild] = allowedFiles; // Save the array of files
    }
    if (feild != "file") {
      updatedtaskdetails[feild] = value;
    }

    setTaskdetails(updatedtaskdetails);
  };

  const fetchprojects = async () => {
    const query = `
        
query AllProjects3 {
    allProjects {
        id
        title
        projectCode
        description
        startDate
        endDate
        tasks {
            id
            title
            description
            status
            priorityLevel
            estimatedHours
            completedHours
            dueDate
            startDate
            completedAt
            createdAt
            updatedAt
            statusDisplay
            priorityLevelDisplay
            assignedBy {
                id
                lastLogin
                isStaff
                isActive
                dateJoined
                email
                empid
                salutation
                department
                designation
                contactNumber
                emergencyContact
                dateOfBirth
                grade
                gender
                employeeType
                probationPeriod
                login
                logout
                attendanceId
                teamleader
                lastUpdate
                username
                firstName
                lastName
                fathersName
                maritalStatus
                previousExperience
                address
                country
                state
                city
                zipCode
                dateOfJoining
                LastWorkingDay
                secondaryContactNumber
                isUser
                otApplicable
                shift
                officialMail
                aadharNumber
                panNumber
                uanNumber
                memberId
                esicNumber
                createdAt
                password
                isSuperuser
            }
            createdBy {
                id
                lastLogin
                isStaff
                isActive
                dateJoined
                email
                empid
                salutation
                department
                designation
                contactNumber
                emergencyContact
                dateOfBirth
                grade
                gender
                employeeType
                probationPeriod
                login
                logout
                attendanceId
                teamleader
                lastUpdate
                username
                firstName
                lastName
                fathersName
                maritalStatus
                previousExperience
                address
                country
                state
                city
                zipCode
                dateOfJoining
                LastWorkingDay
                secondaryContactNumber
                isUser
                otApplicable
                shift
                officialMail
                aadharNumber
                panNumber
                uanNumber
                memberId
                esicNumber
                createdAt
                password
                isSuperuser
            }
            project {
                id
                title
                projectCode
                description
                startDate
                endDate
            }
            attachments {
                id
                objectId
                file
                uploadedAt
            }
        }
    }
}

        
        `;
    try {
      const res = await axios.post(BASEURL, {
        query,
      });
      console.log(res.data.data.allProjects, "allprojectt");

      const data = res?.data?.data?.allProjects?.map((project) => ({
        value: project?.id,
        label: project?.title,
      }));

      setAllprojects(data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchtaskbyid = async (id) => {
    const query = `query TaskById($id: Int!) {
  taskById(id: $id) {
    id
    title
    description
    status
    priorityLevel
    estimatedHours
    completedHours
    dueDate
    startDate
    completedAt
    createdAt
    updatedAt
    statusDisplay
    priorityLevelDisplay
    assignedBy {
      id
      lastLogin
      isStaff
      isActive
      dateJoined
      email
      empid
      salutation
      department
      designation
      contactNumber
      emergencyContact
      dateOfBirth
      grade
      gender
      employeeType
      probationPeriod
      login
      logout
      attendanceId
      teamleader
      lastUpdate
      username
      firstName
      lastName
      fathersName
      maritalStatus
      previousExperience
      address
      country
      state
      city
      zipCode
      dateOfJoining
      LastWorkingDay
      secondaryContactNumber
      isUser
      otApplicable
      shift
      officialMail
      aadharNumber
      panNumber
      uanNumber
      memberId
      esicNumber
      createdAt
      password
      isSuperuser
    }
    createdBy {
      id
      lastLogin
      isStaff
      isActive
      dateJoined
      email
      empid
      salutation
      department
      designation
      contactNumber
      emergencyContact
      dateOfBirth
      grade
      gender
      employeeType
      probationPeriod
      login
      logout
      attendanceId
      teamleader
      lastUpdate
      username
      firstName
      lastName
      fathersName
      maritalStatus
      previousExperience
      address
      country
      state
      city
      zipCode
      dateOfJoining
      LastWorkingDay
      secondaryContactNumber
      isUser
      otApplicable
      shift
      officialMail
      aadharNumber
      panNumber
      uanNumber
      memberId
      esicNumber
      createdAt
      password
      isSuperuser
    }
    project {
      title
      id
      startDate
      endDate
    }
    attachments {
      id
      objectId
      file
      uploadedAt
    }
  }
}

`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data.data.taskById, "fetched task");
      const fetchedtask = response.data.data.taskById;

      setTaskdetails({
        id: fetchedtask?.id,
        projectname: {
          value: fetchedtask?.project?.id,
          label: fetchedtask?.project?.title,
        },
        projectnameStatus: "success",
        employee: {
          value: fetchedtask?.assignedBy?.id,
          label: fetchedtask?.assignedBy?.firstName,
        },
        employeeStatus: "success",
        title: fetchedtask?.title,
        titleStatus: "success",
        //  status:{value:}
        startdate: fetchedtask?.startDate,
        startdateStatus: fetchedtask?.startDate
          ? "success"
          : "unchecked",
        enddate: fetchedtask?.dueDate,
        enddateStatus: fetchedtask?.dueDate ? "success" : "unchecked",
        prioritylevel: {
          value: fetchedtask?.priorityLevel.toLowerCase(),
          label: fetchedtask?.priorityLevel,
        },
          status: {
          value: fetchedtask?.status.toLowerCase(),
          label: fetchedtask?.status,
        },
        statusStatus:"success",
        prioritylevelStatus: "success",
        estimatedhours: fetchedtask?.estimatedHours,
        estimatedhoursStatus: "success",
        duedate: fetchedtask?.dueDate,
        duedateStatus: "success",
        description: fetchedtask?.description,
        descriptionStatus: "success",
        file: [],
        fileStatus: "success",
      });

      const attachments = fetchedtask?.attachments;
      console.log(attachments,"aamentt");

      const filewithurl = attachments.map((file)=>({
        name:file.file.slice(5),
        url:pdfurl+file.file,
        id:file?.id
      }))
      setfiles(filewithurl)
      

      const filename = attachments.map(
        (attachment) => attachment.file.slice(5) + ","
      );
      setfilename(filename);

      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const fetchemployee = async () => {
    const query = `query{
        allUsersDetail{
        id
        lastLogin
        username
        firstName
        lastName
        isActive
        dateJoined
        email
        salutation
        dateOfBirth
        contactNumber
        emergencyContact
        gender
        employeeType
        lastUpdate
        department
        designation
        empid
        teamleader 
        grade
        role{
        role
        }
        }}`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract Employee data from the response
      const EmpList = response.data.data.allUsersDetail;
      console.log("EmpList:", EmpList);

      let filterdata = EmpList.filter((val) => val.empid != "").map((emp) => ({
        value: emp?.id,
        label: emp?.firstName,
      }));
      console.log("filterdata:", filterdata);

      setEmployee(filterdata);

      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const Addtask = async () => {
    setCirleLoading(true);

    const query = `
        mutation CreateTask(
  $createdById: Int!, 
  $estimatedHours: Decimal!, 
  $title: String!, 
  $description: String!, 
  $startDate:Date!,
  $dueDate: Date!, 
  $priorityLevel: String!, 
  $projectId: Int!, 
  $assignedById: Int!, 
  $files: [Upload]
) {
  createTask(
    createdById: $createdById, 
    estimatedHours: $estimatedHours, 
    title: $title, 
    description: $description, 
    startDate:$startDate,
    dueDate: $dueDate, 
    priorityLevel: $priorityLevel, 
    projectId: $projectId, 
    assignedById: $assignedById, 
    files: $files
  ) {
    success
    message
    error
  }
}

   `;
  const update = `
  mutation UpdateTask(
    $id: Int!,
    $assignedById: Int,
    $description: String,
    $startDate: Date!,
    $dueDate: Date,
    $estimatedHours: Decimal,
    $priorityLevel: String,
    $projectId: Int,
    $status: String,
    $title: String
  ) {
    updateTask(
      id: $id,
      assignedById: $assignedById,
      description: $description,
      startDate: $startDate,
      dueDate: $dueDate,
      estimatedHours: $estimatedHours,
      priorityLevel: $priorityLevel,
      projectId: $projectId,
      status: $status,
      title: $title
    ) {
      success
      message
      error
      task {
        id
        title
        description
        status
        priorityLevel
        estimatedHours
        completedHours
        dueDate
        startDate
        completedAt
        createdAt
        updatedAt
        statusDisplay
        priorityLevelDisplay
        assignedBy {
          id
          username
          email
        }
        createdBy {
          id
          username
          email
        }
        project {
          id
          title
          projectCode
        }
        attachments {
          id
          file
          uploadedAt
        }
      }
    }
  }
`;


    let variables;
    if (!status.edit) {
      variables = {
        createdById: userid,
        estimatedHours: taskdetails.estimatedhours,
        title: taskdetails.title,
           startDate:taskdetails.startdate,
        // endDate:taskdetails?.duedate,
        description: taskdetails.description,
        dueDate: taskdetails.duedate,
        priorityLevel: taskdetails.prioritylevel.value,
        projectId: taskdetails.projectname.value,
        assignedById: taskdetails.employee.value,
        files:
          taskdetails?.file.length > 0
            ? taskdetails?.file.map(() => null)
            : null, // placeholder array matching number of files
      };
    } else {
      variables = {
        id: taskdetails?.id,
        createdById: userid,
        estimatedHours: taskdetails.estimatedhours,
        title: taskdetails.title,

        description: taskdetails.description,
        startDate:taskdetails.startdate,
        endDate:taskdetails?.enddate,
        dueDate: taskdetails.duedate,
        priorityLevel: taskdetails.prioritylevel.value,
        projectId: taskdetails.projectname.value,
        assignedById: taskdetails.employee.value,
        status:taskdetails?.status.value,
        files:
          taskdetails?.file.length > 0
            ? taskdetails?.file.map(() => null)
            : null, // placeholder array matching number of files
      };
    }

    try {
      const formData = new FormData();
      // Step 1: Create the GraphQL operations
      const operations = JSON.stringify({
        query: status.edit ? update : query,
        variables,
      });
      formData.append("operations", operations);

      // Step 2: Create the map for multiple files
      const map = {};
      if (taskdetails.file.length > 0) {
        taskdetails.file?.forEach((_, index) => {
          map[index] = [`variables.files.${index}`];
        });
      }
      formData.append("map", JSON.stringify(map));

      // Step 3: Append each file
      if (taskdetails.file.length > 0) {
        taskdetails.file?.forEach((file, index) => {
          formData.append(index.toString(), file);
        });
      }

      let response;
      try {
        response = await axios.post(BASEURL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log(response.data);
      } catch (error) {
        console.error("Error uploading files:", error);
      }
        let message;
        let error;
        let success;
        if(status.edit){
          message = response.data.data.updateTask.message
          success = response.data.data.updateTask.success
          error = response.data.data.updateTask.error
        }
        else{
            message = response.data.data.createTask.message
          success = response.data.data.createTask.success
          error = response.data.data.createTask.error
        }

      

      if (error) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: message,
          showConfirmButton: false,
          timer: 2500,
        });
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //     ...snackBar,
      //     Success: true
      // })
      if (success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: message,
          showConfirmButton: false,
          timer: 2500,
        });
        // nav("/employee-management");
      }
      setCirleLoading(false);
      // setCirleLoading(false)
      // navigate("/employee-management");
      nav("/task-allocation");
    } catch (error) {
      console.error("responseError:", error.message);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      // setCirleLoading(false)
    }
  };

   const Deletetask = async (id) => {
    setCirleLoading(true);

     const Delete =`
      mutation DeleteTask($id: Int!) {
  deleteTask(id: $id) {
    success
    message
    error
  }
}


     
     `



    try {
      
      let response;
   
        response = await axios.post(BASEURL, {
          query:Delete,
          variables:{
            id:parseInt(id)
          }
        });
        console.log(response.data);
      
      
    
        let message;
        let error;
        let success;
       
          message = response.data.data.deleteTask.message
          success = response.data.data.deleteTask.success
          error = response.data.data.deleteTask.error
        
       

      

      if (error) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: message,
          showConfirmButton: false,
          timer: 2500,
        });
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //     ...snackBar,
      //     Success: true
      // })
      if (success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: message,
          showConfirmButton: false,
          timer: 2500,
        });
        // nav("/employee-management");
      }
      setCirleLoading(false);
      // setCirleLoading(false)
      // navigate("/employee-management");
      nav("/task-allocation");
    } catch (error) {
      console.error("responseError:", error.message);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      // setCirleLoading(false)
    }
  };
  const handleAddTask = (Delete=false) => {
    console.log(Delete,"del inside confirm");
    
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: Delete?"Are you sure do you want to Delete your Task?":"Are you sure do you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
       Delete?Deletetask(id): Addtask();

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setstatus({
      edit: true,
      view: false,
    });
  };

  const checkAllFields = ()=>{
    let disable = true
    if(taskdetails.projectnameStatus=="success" && taskdetails.titleStatus=="success"

        && taskdetails.prioritylevelStatus=="success" && taskdetails.estimatedhoursStatus=="success" 
        && taskdetails.duedateStatus=="success" 
        && taskdetails.employeeStatus=="success"

    ){
      disable = false
    }
    return disable;
  }

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Pdfdialog open={open} setopen={setopen} files={files} />

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {/* {togglePage.view ? "View Employee Details" : "Edit Employee Details"}   */}
                </MaterialTypography>
              </Stack>

              {id && (
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                  { task!="mytask" &&
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={()=>handleAddTask(true)}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </MaterialButton>}
                </ButtonGroup>
              )}
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              {/* projectname */}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Project Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="reason"
                  //   placeholder="Auto generated"

                  options={Allprojects}
                  value={taskdetails.projectname}
                  onChange={(e) => handletaskdetails("projectname", e)}
                  success={taskdetails?.projectnameStatus == "success"}
                  error={taskdetails?.projectnameStatus == "error"}
                  isDisabled={status.view || task=="mytask"}
                />
              </Grid>
              {/* Allemployee */}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Assigned To <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="reason"
                  //   placeholder="Auto generated"

                  options={Employee}
                  value={taskdetails.employee}
                  onChange={(e) => handletaskdetails("employee", e)}
                  success={taskdetails?.employeeStatus == "success"}
                  error={taskdetails?.employeeStatus == "error"}
                    isDisabled={status.view||  task=="mytask" }
                />
              </Grid>

              {/* task  title */}
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Task Title <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="Title"
                  value={taskdetails.title}
                  onChange={(e) => handletaskdetails("title", e.target.value)}
                  error={taskdetails.titleStatus === "error" ? true : false}
                  success={taskdetails.titleStatus === "success" ? true : false}
                  disabled={status.view||  task=="mytask"}
                />
              </Grid>

              {/* startdate */}
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Start Date
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="startdate"
                  type="date"
                  value={taskdetails.startdate}
                  onChange={(e) =>
                    handletaskdetails("startdate", e.target.value)
                  }
                  error={taskdetails.startdateStatus === "error"}
                  success={taskdetails.startdateStatus === "success"}
                   disabled={status.view}
                />
              </Grid>

              {/* enddate */}
              {/* <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    End Date 
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="startdate"
                  type="date"
                  value={taskdetails.enddate}
                  onChange={(e) => handletaskdetails("enddate", e.target.value)}
                  error={taskdetails.enddateStatus === "error"}
                  success={taskdetails.enddateStatus === "success"}
                   disabled={status.view}
                />
              </Grid> */}

              {/* priority level */}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Priority Level <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="priority level"
                  //   placeholder="Auto generated"

                  options={prioritylevel}
                  value={taskdetails.prioritylevel}
                  onChange={(e) => handletaskdetails("prioritylevel", e)}
                  success={taskdetails?.prioritylevelStatus == "success"}
                  error={taskdetails?.prioritylevelStatus == "error"}
                   isDisabled={status.view||  task=="mytask"}
                />
              </Grid>

              {/* status */}

             { task =="mytask"&& <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Status
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="status"
                  //   placeholder="Auto generated"

                  options={statusoptions}
                  value={taskdetails.status}
                  onChange={(e) => handletaskdetails("status", e)}
                  success={taskdetails?.statusStatus == "success"}
                  error={taskdetails?.statusStatus == "error"}
                   isDisabled={status.view}
                />
              </Grid>}

              {/* estimated Hours */}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Estimated Hours  <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="number"
                  name="estimated Hours"
                  value={taskdetails.estimatedhours}
                  onChange={(e) =>
                    handletaskdetails("estimatedhours", e.target.value)
                  }
                  error={
                    taskdetails.estimatedhoursStatus === "error" ? true : false
                  }
                  success={
                    taskdetails.estimatedhoursStatus === "success"
                      ? true
                      : false
                  }
                 disabled={status.view}
                />
              </Grid>

              {/* duedate */}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Due Date  <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="duedate"
                  type="date"
                  value={taskdetails.duedate}
                  onChange={(e) => handletaskdetails("duedate", e.target.value)}
                  error={taskdetails.duedateStatus === "error"}
                  success={taskdetails.duedateStatus === "success"}
                   disabled={status.view||  task=="mytask"}
                />
              </Grid>

              {/* description */}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Description 
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  multiline
                  rows={2}
                  value={taskdetails.description}
                  onChange={(e) =>
                    handletaskdetails("description", e.target.value)
                  }
                  error={taskdetails.descriptionStatus === "error"}
                  success={taskdetails.descriptionStatus === "success"}
                  disabled={status.view||  task=="mytask"}
                />
                {taskdetails.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description should be a minimum 10 characters & maximum
                      100 characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid
                //   mt={Finalresult[0]?.halfDayAllowed == false ? -8 : 0}
                size={{ xs: 5, sm: 4 }}
              >
                <MaterialBox lineHeight={0} display="inline-block" mb={0}>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Upload the Document <span style={{ color: "red" }}>*</span> <IconButton onClick={()=>setopen(true)}>
                      <RemoveRedEyeIcon  />
                    </IconButton>
                  </MaterialTypography>
                </MaterialBox>

                <Box
                  component="label"
                  htmlFor="upload-file"
                  sx={{
                    border: "2px dashed #90caf9",
                    borderRadius: "12px",
                    padding: "21px 43px",
                    width: "100%",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#f5faff",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                    },
                  }}
                >
                  <CloudUploadIcon sx={{ fontSize: 50, color: "#2196f3" }} />
                  <Typography sx={{ mt: 1, color: "#2196f3", fontWeight: 500 }}>
                    Browse file to upload
                  </Typography>
                  <input
                    hidden
                    multiple
                    disabled={id?true:false}
                    id="upload-file"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => handletaskdetails("file", e)}
                  />
                </Box>

                {taskdetails?.fileStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please upload a valid document (PDF, JPG, PNG).
                    </FormHelperText>
                  </FormControl>
                )}

                <FormHelperText>{filename}</FormHelperText>
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        {status.edit || !id ? (
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // onClick={handleCancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                disabled={checkAllFields()}
                onClick={()=>handleAddTask(false)}
              >
                {status?.edit ? "Update" : "Submit"}
              </MaterialButton>
            </>
          </MaterialBox>
        ) : (
          ""
        )}
      </Card>
    </DashboardLayout>
  );
};

export default AllocateTask;